var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('popAnimation', {
    attrs: {
      "visible": _vm.visible
    }
  }, [_c('div', {
    staticClass: "appExclusive"
  }, [_c('h5', {
    staticClass: "ae_title"
  }, [_vm._v("优惠信息")]), _c('div', {
    staticClass: "ae_price"
  }, [_c('p', {
    staticClass: "price_label"
  }, [_c('img', {
    staticClass: "label",
    attrs: {
      "src": require("./../img/phone_icon.png")
    }
  }), _vm._v("APP专享价\n      ")]), _c('span', {
    staticClass: "price_offer"
  }, [_vm._v(_vm._s(_vm.good.activityPrice))]), _c('span', {
    staticClass: "price_origin"
  }, [_vm._v("￥" + _vm._s(_vm.good.wxActivityPrice))])]), _c('p', {
    staticClass: "ae_tip"
  }, [_vm._v("下载云客赞APP购买该商品可直减￥" + _vm._s(_vm.good.addPrice))]), _c('div', {
    staticClass: "ae_btns"
  }, [_c('div', {
    staticClass: "ae_btn",
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("取消")]), _c('div', {
    staticClass: "ae_btn ae_btn--color",
    on: {
      "click": _vm.handleDownload
    }
  }, [_vm._v("去下载")])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };